import React from "react";
import { HandbookEntriesPage } from "./HandbookEntriesPage";
import { useHandbookEntries } from "./useHandbookEntries";

function HandbookEntries() {
  return <HandbookEntriesPage {...useHandbookEntries()} />;
}

export default HandbookEntries;
